import { css } from '@/styled-system/css';

export const tabsContainerOverride = css({
  paddingX: '2x',
});

export const pillsContainer = css({
  display: 'flex',
  gap: '1x',
  paddingX: '2x',
  paddingTop: '2x',
  paddingBottom: '0',
});

export const pill = css({
  paddingX: '2x',
  paddingY: 'xs',
  borderRadius: '20px',
  fontSize: 'sm',
  fontWeight: '700',
  border: 'none',
  cursor: 'pointer',
  transitionProperty: 'background-color, color',
  transitionDuration: '0.2s',
  _focusVisible: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '2px',
  },
});

export const pillActive = css({
  backgroundColor: 'hpxTeal500',
  color: 'hpxWhite',
});

export const pillInactive = css({
  backgroundColor: '#6E6E6E99',
  color: 'hpxWhite',
  cursor: 'not-allowed',
});

export const photosGrid = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '1x',
  paddingX: '2x',
  paddingY: '1x',
  md: {
    display: 'grid',
    gridTemplateColumns: 'repeat(10, 1fr)',
    gap: '1x',
    '& > *:nth-child(4n+1)': {
      gridColumn: 'span 6',
    },
    '& > *:nth-child(4n+2)': {
      gridColumn: 'span 4',
    },
    '& > *:nth-child(4n+3)': {
      gridColumn: 'span 4',
    },
    '& > *:nth-child(4n+4)': {
      gridColumn: 'span 6',
    },
  },
});

export const photoButton = css({
  display: 'block',
  width: '100%',
  padding: 0,
  border: 'none',
  backgroundColor: 'transparent',
  cursor: 'pointer',
  borderRadius: '8px',
  overflow: 'hidden',
  aspectRatio: '4/3',
  _focusVisible: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '2px',
  },
  md: {
    borderRadius: '12px',
    height: '280px',
  },
});

export const photoImage = css({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  display: 'block',
});

export const tourContainer = css({
  padding: '2x',
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minHeight: 0,
});

export const tourPreview = css({
  position: 'relative',
  width: '100%',
  borderRadius: '8px',
  overflow: 'hidden',
  backgroundColor: 'hpxGrey100',
  md: {
    flex: 1,
    minHeight: 0,
  },
});

export const tourPreviewImage = css({
  width: '100%',
  aspectRatio: '4/3',
  objectFit: 'cover',
  display: 'block',
  md: {
    aspectRatio: 'auto',
    height: '100%',
  },
});

export const tourPreviewImageBlurred = css({
  width: '100%',
  aspectRatio: '4/3',
  objectFit: 'cover',
  display: 'block',
  filter: 'blur(8px)',
  transform: 'scale(1.1)',
  md: {
    aspectRatio: 'auto',
    height: '100%',
  },
});

export const tourOverlay = css({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'rgba(0, 0, 0, 0.3)',
});

export const tourIconCircle = css({
  width: '64px',
  height: '64px',
  borderRadius: '50%',
  backgroundColor: 'rgba(0, 0, 0, 0.6)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: '1x',
});

export const tourLabel = css({
  backgroundColor: 'rgba(0, 0, 0, 0.7)',
  color: 'hpxWhite',
  paddingX: '2x',
  paddingY: 'xs',
  borderRadius: '4px',
  fontSize: 'sm',
  fontWeight: '500',
});

export const tourButton = css({
  backgroundColor: 'transparent',
  border: 'none',
  cursor: 'pointer',
  width: '100%',
  padding: 0,
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  _focusVisible: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '2px',
  },
});

export const tourList = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '2x',
});

export const emptyState = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '6x',
  color: 'hpxGrey500',
  fontSize: 'md',
});

export const footerActions = css({
  display: 'flex',
  gap: '1x',
  width: '100%',
  maxWidth: '400px',
});
